import { PublicationTargetsSchema } from '@eigtech/claims-v2-types';
import { NoteCornSchema, NotePublicationTargetSchema } from '@eigtech/notes-types';
import { InspectionCornSchema, InspectionEntityCornSchema } from './base.js';
import { z } from 'zod';
export const AddInspectionNoteToEntityParamsSchema = z.object({
    entityId: InspectionEntityCornSchema,
    title: z.string(),
    text: z.string(),
    createdBy: z.string(),
    createdOn: z.iso.datetime().optional(),
});
export const MarkInspectionNoteForPublicationParamsSchema = z.object({
    noteId: NoteCornSchema,
    publicationTargets: NotePublicationTargetSchema.array(),
});
export const PublishInspectionMediaParamsSchema = z.object({
    entityId: InspectionEntityCornSchema,
    inspectionId: InspectionCornSchema,
    publicationTargets: PublicationTargetsSchema.array(),
});
export const LabelFilterSchema = z.object({
    labels: z.string().optional(),
    labelOperand: z.enum(['AND', 'OR']).optional(),
});
